import { baseUrl } from "../../../boot/index";
import axios from "axios";

// assign sites lookup
export const assignSites = async (data) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/operations/app/v1/assign-sites`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}
// Add Sites
export const addSites = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/operations/app/v1/create-sites`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log({ error })
    throw error
  }
}

// update Sites
export const updateSites = async (data) => {
  console.log({ data })
  const ROWID = data.ROWID
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/operations/app/v1/update-sites/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}
// delete Sites 
export const deleteSites = async (ROWID) => {
  console.log({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/operations/app/v1/delete-sites/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ", error)
    throw error
  }
}
// total count
export const countSites = async (formData) => {
  const token = localStorage.getItem("authToken")
  // console.log('<<<<<<<<<<<<<<token',token)
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/operations/app/v1/count-sites`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}
// Get Sites by ID
export const getSitesById = async (ROWID) => {
  console.warn({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/operations/app/v1/get-related-list/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
};



